import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const juneMap: Array<IPixelMapDay> = [
	{
		status: "above-average",
		title: "Across the Spider-Verse",
		icon: "cinematic_blur",
		reason: "I watched Spider-Man: Across the Spider-Verse today and it was pretty inspiring.",
		spotify: {
			artist: "LE SSERAFIM",
			album: "Unforgiven",
			song: "Flash Forward",
			link: "https://open.spotify.com/track/74cpuIw43kA8xPgbQEPdss?si=6c795047e36749c9"
		}
	},
	{
		status: "above-average",
		reason: "In the afternoon, I also bought and packaged some sweets and candy for Kai, then I included my old phone. It's been a while since I've been this giving and I feel a little better by giving.",
		spotify: {
			artist: "STAYC",
			song: "LOVE FOOL",
			link: "https://open.spotify.com/track/2OhOkew9BkkLTGBG9cFOz5?si=d7498fc4888f48c7",
			album: "STAYDOM"
		}
	},
	{
		status: "above-average",
		reason: "I mostly did chores today, I finally cleaned all of the plates and utensils into that new dishwasher set.",
		spotify: {
			artist: "STAYC",
			song: "SO WHAT",
			link: "https://open.spotify.com/track/6hC2Qn11Fzw4Ufi4XH6z2m?si=4dc3c4bdfbe04889",
			album: "STAYDOM"
		}
	},
	{
		status: "awful",
		title: "The Pressure Cooker",
		icon: "cooking",
		reason: "This was a hard day to get through. I felt the full weight of my future on my shoulders. I met up with a friend, Nathan, to discuss things with and he offered great support. I haven't seen the guy in years and I think he's doing great. I appreciate him being there for me, even bringing along his gf."
	},
	{
		status: "above-average",
		title: "A Litany Against Fear",
	},
	{
		status: "above-average",
		reason: "It was an okay day, I felt overly-busy at work and I passed out after playing Phasmo.",
		spotify: {
			artist: "Vengaboys",
			song: "Shalala Lala",
			link: "https://open.spotify.com/track/4pV49P2v3sxI0XYjUTmOl1?si=3a9a2f1ea2e74a5c",
			album: "The Platinum Album"
		}
	},
	{
		status: "above-average",
		reason: "I'm trying to get better at playing Phasmo. I talked to other people as well today, including Kai. My time alone after work was fun.",
		spotify: {
			artist: "LE SSERAFIM",
			album: "Unforgiven",
			song: "UNFORGIVEN",
			link: "https://open.spotify.com/track/51vRumtqbkNW9wrKfESwfu?si=91a7ed9f902f40d6"
		}
	},
	{
		status: "above-average",
		spotify: {
			artist: "PinkPanthress, Ice Spice",
			album: "Boy's a liar Pt. 2",
			song: "Boy's a liar Pt. 2",
			link: "https://open.spotify.com/track/6AQbmUe0Qwf5PZnt4HmTXv?si=e2b345c1591b4f58"
		}
	},
	{
		status: "above-average",
		reason: "I have made the decision to fight for my life today. I really should do better, and I'm gonna.",
		spotify: {
			artist: "SEVENTEEN",
			album: "SEVENTEEN 10th Mini Album 'FML'",
			song: "F*ck My Life",
			link: "https://open.spotify.com/track/3tgWMPOY4stCdKYj5NjrAe?si=4d3cc388b1404286"
		}
	},
	{
		status: "good",
		icon: "flashlight_on",
		title: "Who You Gonna Call?",
		reason: "I also started work (and completed) that *actual* dynamic theming for my website. I also ate good food today, which is always nice.",
		spotify: {
			artist: "Taylor Swift",
			album: "Lover",
			song: "London Boy",
			link: "https://open.spotify.com/track/1LLXZFeAHK9R4xUramtUKw?si=982fab4c655b441a"
		}
	},
	{
		status: "below-average",
		reason: "I launched a new feature for my website that I'm excited about. Still, I kind of wasted half of my day by staying up late and waking up at 1 p.m.",
		spotify: {
			artist: "IZ*ONE",
			song: "La Vie en Rose",
			link: "https://open.spotify.com/track/3WfaJhCL4p2JbdffJjV6Va?si=b2ac2f5bd0be4997",
			album: "COLOR*IZ"
		}
	},
	{
		status: "good",
		icon: "sports_esports",
		title: "Time Controller",
		reason: "I decided to get a controller today after deciding I've worked enough for the features on this website. I had enough time in the afternoon to go out and buy a PS5 controller and had a lot of fun setting it up and playing the PS2 and PS3 games that I love. I also got to stay up late with my friends and watch In Time with them.",
		spotify: {
			artist: "Megan Thee Stallion, Dua Lipa",
			song: "The Sweetest Pie",
			link: "https://open.spotify.com/track/7mFj0LlWtEJaEigguaWqYh?si=e714de189c8f4921",
			album: "Sweetest Pie"
		}
	},
	{
		status: "below-average",
		icon: "repeat_one",
		reason: "I'm just tired and exhausted right now. Things aren't okay now, and I doubt they would be for some time.",
		spotify: {
			artist: "Jonas Brothers",
			song: "Sucker",
			link: "https://open.spotify.com/track/22vgEDb5hykfaTwLuskFGD?si=b8baf642053e4b44",
			album: "Happiness Begins"
		}
	},
	{
		status: "below-average",
		title: "In All Rightful Places",
		icon: "published_with_changes",
		reason: "Things just returned to their rightful place again. The status quo remains and the usual day-to-day was back.",
		spotify: {
			artist: "Taylor Swift",
			song: "All Too Well (10 Minute Version) (Taylor's Version) (From The Vault)",
			link: "https://open.spotify.com/track/5enxwA8aAbwZbf5qCHORXi?si=8a6d29fa4d3a4e64",
			album: "Red (Taylor's Version)"
		}
	},
	{
		status: "above-average",
		reason: "Things were okay today. I was busy with work and I felt like I accomplished a lot of my tasks. We also completed the Community Center in Stardew today! My friends also showed me AI covers of Girls' Generation.",
		spotify: {
			artist: "sped up 8282",
			album: "Cupid – Twin Ver. (FIFTY FIFTY) – Sped Up Version",
			song: "Cupid – Twin Ver. (FIFTY FIFTY) – Sped Up Version",
			link: "https://open.spotify.com/track/3B228N0GxfUCwPyfNcJxps?si=00fb3ea3ee5d43db"
		}
	},
	{
		status: "above-average",
		reason: "I was able to play a lot of controller-only games with my new controller. My time alone was fun. I wanted to go with my friends for a vacation out of town during the weekend, but I couldn't go. That's okay, I'll try to make the most out of my weekend.",
		spotify: {
			song: "Cupid",
			artist: "FIFTY FIFTY",
			link: "https://open.spotify.com/track/5mg3VB3Qh7jcR5kAAC4DSV?si=25da916856c54a4f",
			album: "The Beginning: Cupid"
		}
	},
	{
		status: "good",
		reason: "I'm actually surprised I got to play a lot of games today. In the morning, we played Stardew Valley and then It Takes Two, then in the afternoon we played Phasmophobia with their cousin, and then Hogwarts Legacy in the evening. They had time in the evening so we played Stardew Valley again to cap the day off. I also ate good food, so that was a big boost for my mood. Really tied in a really good Saturday: just quality time, rest, good food, and gaming.",
		spotify: {
			song: "Thriller",
			artist: "Michael Jackson",
			link: "https://open.spotify.com/track/3S2R0EVwBSAVMd5UMgKTL0?si=413017d4c58e40c6",
			album: "Thriller 25 Super Deluxe Edition"
		}
	},
	{
		status: "average",
	},
	{
		status: "below-average",
		title: "If You Could See Me, Whoever I Am",
		reason: "I really need to start to fight for my life or smth. I don't really feel great about my current position at the moment. I'm going to try to do some things that'll hopefully change my outlook and position eventually.",
		spotify: {
			artist: "fun\.",
			album: "Aim and Ignite",
			song: "Walking The Dog",
			link: "https://open.spotify.com/track/1lLJ6dT1CcyheZZyr7gJy4?si=c2d853cc2ea24179"
		}
	},
	{
		status: "bad",
		reason: "I need to keep working out. This isn't enough.",
		spotify: {
			artist: "SEVENTEEN",
			album: "SEVENTEEN 10th Mini Album 'FML'",
			song: "F*ck My Life",
			link: "https://open.spotify.com/track/3tgWMPOY4stCdKYj5NjrAe?si=4d3cc388b1404286"
		}
	},
	{
		status: "good",
		reason: "I'm glad.",
		spotify: {
			artist: "NIKI",
			album: "lowkey",
			song: "lowkey",
			link: "https://open.spotify.com/track/5TTXEcfsYLh6fTarLaevTi?si=9413851ede134edc"
		}
	},
	{
		status: "above-average",
		reason: "My mood from the morning was pretty upbeat.",
		spotify: {
			artist: "Claire Rosinkranz",
			album: "Frankenstein",
			song: "Frankenstein",
			link: "https://open.spotify.com/track/1xSmjB0t19q4CSJ0X0ymGB?si=22dc237cdc1b4fac"
		}
	},
	{
		status: "below-average",
		reason: "I got to call the friends I haven't talked to in a long time.",
		spotify: {
			artist: "The J. Geils Band",
			album: "Freeze Frame",
			song: "Centerfold",
			link: "https://open.spotify.com/track/1ynmMEK1fkyiZ6Z6F3ThEt?si=ef1c3b7d64284c49"
		}
	},
	{
		status: "special",
		icon: "ice_skating",
		title: "It’s a Date, A Double Date!",
		reason: "I was pulled by Nathan and their girlfriend into a double date. As much as I wanted to, the date didn't actually turn out okay. It felt like I wasn't being myself and I kept getting pressured to be my friends I'm not. I didn't feel genuine, I felt the most fake I could ever be. It was also unfortunate that my date wasn't that cool either, they really triggered my pet peeve. Most of the time, they just kept scrolling on their phone and were just absorbed in their feed, while I did my best to keep my phone in my pocket and be in the moment. This is my first actual date, but I've hung out with a lot of friends and my hangouts were way better. It speaks volumes, honestly. I tried to have fun and my date was nice at the end, they bought me some coffee and they were nice when I was talking to their. But I'm not really going to push through with them, we couldn't find common ground and it wasn't that much of a good day.",
		spotify: {
			artist: "(G)I-DLE",
			album: "I feel",
			song: "Queencard",
			link: "https://open.spotify.com/track/4uOBL4DDWWVx4RhYKlPbPC?si=75a8dd714a1349f7"
		}
	},
	{
		status: "average",
		spotify: {
			artist: "Alamat",
			album: "Pasulong",
			song: "Marahani",
			link: "https://open.spotify.com/track/6KAnNItOZJ85PT3s0KqMgT?si=5d4fc7900c744da6"
		}
	},
	{
		status: "above-average",
		reason: "Start of the week and everything felt normal and familiar.",
		spotify: {
			artist: "(G)I-DLE",
			album: "I feel",
			song: "Queencard",
			link: "https://open.spotify.com/track/4uOBL4DDWWVx4RhYKlPbPC?si=75a8dd714a1349f7"
		}
	},
	{
		status: "good",
		reason: "Honestly, I'm surprised I had to go out today for some in-person work meeting in QC. I met the other member of our team and our project lead. I had a fun day out! I also got to reconnect with an old friend.",
	},
	{
		status: "above-average",
		reason: "I actually forgot that today was a holiday but I just spent the entire day playing games, having fun with Monopoly.",
		spotify: {
			artist: "James Arthur",
			album: "Back from the Edge",
			song: "Say You Won't Let Go",
			link: "https://open.spotify.com/track/5uCax9HTNlzGybIStD3vDh?si=24dfcaec196d43f6"
		}
	},
	{
		status: "good",
		reason: "Today was a pretty good day. In the evening, I asked my little sister to go out with me at this Korean BBQ restaurant that I frequent. We had a lot of fun and hoped that Aespa would show up on the MVs playing on the TV. Only on the ride home did Aespa's \"Welcome To MY World\" play and it shocked us both when it played.",
		spotify: {
			artist: "aespa",
			album: "MY WORLD - The 3rd Mini Album",
			song: "Welcome To MY World (feat. nævis)",
			link: "https://open.spotify.com/track/3q5qpprtugUIEPExuI7tRD?si=ce4a0490af81414b"
		}
	},
	{
		status: "good",
		reason: "I had a lot of fun and it was the Steam Summer Sale, so I got to buy a few games like Spider-Man Remastered on the PC. It was super fun to play and I also played other games like Monopoly and Cuphead.",
		spotify: {
			artist: "The J. Geils Band",
			album: "Freeze Frame",
			song: "Centerfold",
			link: "https://open.spotify.com/track/1ynmMEK1fkyiZ6Z6F3ThEt?si=ef1c3b7d64284c49"
		}
	},
];

export default juneMap;
